import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asaheducation',
  templateUrl: './asaheducation.component.html',
  styleUrls: ['./asaheducation.component.scss']
})
export class AsaheducationComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
